module.exports = require('./helpers/bundle-url').getBundleURL('adEVu') + "logo.7718c6df.svg";